import PropTypes from "prop-types"
import React from "react"
import Select from "react-select"
import "react-select/dist/react-select.css"
import "./DepartmentDropdown.scss"

class DepartmentDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      selectedOption: props.departments ? props.departments[0] : undefined,
    }
  }

  static getDerivedStateFromProps(props, prevState) {
    if (prevState.selectedOption === undefined && props.departments) {
      return { selectedOption: props.departments[0] }
    } else {
      return null
    }
  }

  handleChange = selectedOption => {
    this.setState({ selectedOption })
    this.props.departmentUpdated(selectedOption)
  }

  render() {
    const { selectedOption } = this.state

    return (
      <div className="DepartmentDropdown">
        <label for="DepartmentDropdown" className="hidden">
          Department Dropdown
        </label>
        <Select
          id="DepartmentDropdown"
          name="DepartmentDropdown"
          className="DepartmentDropdown"
          value={selectedOption}
          onChange={this.handleChange}
          options={this.props.departments}
          isLoading={this.props.loading}
          clearable={false}
          placeholder="Select a department..."
        />
      </div>
    )
  }
}

DepartmentDropdown.propTypes = {
  departments: PropTypes.arrayOf(
    PropTypes.shape({ value: PropTypes.string, label: PropTypes.string })
  ),
  departmentUpdated: PropTypes.func,
  loading: PropTypes.bool,
}

export default DepartmentDropdown
